import { maybeConvertHeic } from '@/lib/heic-convert';

export const MAX_PRODUCT_DEV_UPLOAD_BYTES = 6 * 1024 * 1024;

export const formatProductDevUploadBytes = (bytes: number) =>
  bytes >= 1024 * 1024
    ? `${(bytes / (1024 * 1024)).toFixed(1)} MB`
    : `${(bytes / 1024).toFixed(0)} KB`;

export const productDevFileToBase64 = (
  file: File,
): Promise<{ body: string; type: string | null }> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        reject(new Error('Invalid file read'));
        return;
      }
      const comma = result.indexOf(',');
      resolve({
        body: comma >= 0 ? result.slice(comma + 1) : result,
        type: file.type || null,
      });
    };
    reader.onerror = () => reject(reader.error ?? new Error('File read error'));
    reader.readAsDataURL(file);
  });

/** Convert iPhone HEIC/HEIF before size validation. Conversion can inflate
 * the payload, so callers must validate the returned file rather than the
 * original. Failure is non-lossy: the original file is returned and the UI
 * can explain that it may not preview. */
export const prepareProductDevUpload = async (
  file: File,
): Promise<{ file: File; conversionFailed: boolean }> => {
  const prepared = await maybeConvertHeic(file);
  return { file: prepared.file, conversionFailed: prepared.failed };
};
